import { useCallback } from 'react'
import useIsSale from './useIsSale'

export const SALE_DISCOUNT_PERCENT = 20

export const SALE_PRODUCT_IDS = [12, 16, 17, 20, 27, 35, 36, 43, 44, 46, 47, 58, 60, 61, 62, 64, 65, 70, 77, 97, 121]

export function isSaleProductId(productId?: number | null) {
  return productId !== undefined && productId !== null && SALE_PRODUCT_IDS.includes(productId)
}

export default function useIsSaleProduct() {
  const isSale = useIsSale()

  return useCallback((productId?: number | null) => {
    return isSale && isSaleProductId(productId)
  }, [isSale])
}
